<template>
  <v-container grid-list-md>
    <v-layout>
      <v-flex v-if="loading">
        <v-content class="ma-5 pa-5 mb-5 pb-5">
          <v-container fluid class="ma-5 pa-5 mb-5 pb-5">
            <v-layout justify-center align-center class="ma-5 pa-5 mb-5 pb-5">
              <v-progress-circular indeterminate color="primary">
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-content>
      </v-flex>
      <v-flex v-if="viewEvent.name" id="eventInfo" class="pb-5">
        <h3 class="mb-3">{{ extract("viewEvent.name", "") }}</h3>
        <p v-if="viewEvent.description">{{ viewEvent.description }}</p>
        <p
          v-if="
            extract('viewEvent.pre-survey.0.Event/Activity URL', false) != ''
          "
        >
          <strong class="fixed-width">URL:</strong>
          <span
            v-html="
              eventLink(
                extract('viewEvent.pre-survey.0.Event/Activity URL', false)
              )
            "
          ></span>
        </p>
        <p v-if="extract('viewEvent.contact_info')">
          <strong class="fixed-width">Contact:</strong>
          {{ extract("viewEvent.contact")
          }}<span
            v-if="
              extract('viewEvent.contact_info') && extract('viewEvent.contact')
            "
            >,</span
          >
          {{ extract("viewEvent.contact_info") }}
        </p>
        <p v-if="viewEvent['dsec_partner']">
          <strong class="fixed-width">Partner:</strong
          >{{ viewEvent["dsec_partner"].name }}
        </p>
        <p v-if="viewEvent['dsec_program']">
          <strong class="fixed-width">Program:</strong
          >{{ viewEvent["dsec_program"].name }}
        </p>
        <p>
          <strong class="fixed-width">Method:</strong
          >{{ eventMethodString(extract("viewEvent.method")) }}
        </p>

        <p
          v-if="
            extract('viewEvent.method') !== 'V' &&
            (extract('viewEvent.street') ||
              extract('viewEvent.city') ||
              extract('viewEvent.state') ||
              extract('viewEvent.venue'))
          "
        >
          <strong class="fixed-width">Location:</strong>
          <span v-if="extract('viewEvent.venue')"
            >{{ extract("viewEvent.venue") }}
          </span>
          <span v-if="extract('viewEvent.street')"
            >{{ extract("viewEvent.street") }}<span v-if="extract('viewEvent.street')">,</span> &nbsp;</span
          >
          </span>
          <span v-if="extract('viewEvent.city')"
            >{{ extract("viewEvent.city")
            }}<span v-if="extract('viewEvent.state')">,</span> &nbsp;</span
          >
          <span v-if="extract('viewEvent.state')"
            >{{ extract("viewEvent.state") }}
          </span>
        </p>

        <p v-if="viewEvent.start_date">
          <strong class="fixed-width">Start:</strong
          >{{ dateUser(viewEvent.start_date) }}
          {{ convertToAmPm(extract("viewEvent.start_time")) }}
          {{ extract("viewEvent.tz") =='Other'? extract("viewEvent.tz_other") : extract("viewEvent.tz") }}
        </p>
        <p v-else>
          <strong class="fixed-width">Date:</strong>
          {{ viewEvent.general_date }}
        </p>
        <p v-if="viewEvent.end_date">
          <strong class="fixed-width">End:</strong
          >{{ dateUser(viewEvent.end_date) }}
          {{ convertToAmPm(extract("viewEvent.end_time")) }}
          {{ extract("viewEvent.tz") =='Other'? extract("viewEvent.tz_other") : extract("viewEvent.tz") }}
        </p>

        <!-- <p v-if="viewEvent.admin_tracking && viewEvent.admin_tracking.priority">
          <strong class="fixed-width">Status:</strong>
          <v-chip v-if="viewEvent.status" label small disabled :class="'s-' + viewEvent.status">{{
            viewEvent.status
          }}</v-chip>
        </p> -->

        <p
          v-if="
            amazeUserCan('admin_view', 'dsec_calendar') ||
            eventOwner(viewEvent['dsec_partner'].id)
          "
        >
          <strong class="wide-width">DSEC funded?</strong>
          <span v-if="viewEvent.dsec_funded"
            >Yes, this is funded by DSEC<span v-if="viewEvent.dsec_funded_only">
              and DSEC only.</span
            ><span v-else>.</span></span
          >
          <span v-else>No, this is not funded by DSEC.</span>
        </p>

        <p>
          <strong class="wide-width">Open to others?</strong>
          <span v-if="viewEvent.open_to_attendees"
            >Yes, this is open to other organizations.</span
          ><span v-else>No, this is not open to other organizations.</span>
        </p>

        <div v-if="eventOwner(viewEvent.dsec_partner.id)" class="pb-3">
          <v-btn
            color="primary"
            class="ml-0"
            flat
            @click="$emit('edit-event', 'event-form', viewEvent)"
          >
            <v-icon class="pr-2" small>fa fa-pen</v-icon> Edit
          </v-btn>
          <v-btn
            flat
            color="primary"
            @click="deleteEvent()"
            v-if="amazeUserCan('administer', 'dsec_calendar')"
          >
            <v-icon class="pr-2" small>fa fa-trash</v-icon> Delete
          </v-btn>
        </div>

        <div v-if="amazeUserCan('admin_view', 'dsec_calendar')">
          <v-divider class="mb-4" />
          <v-btn
            @click.stop="$emit('admin-event', 'admin-form', viewEvent)"
            icon
            flat
            class="mx-0 icon-only"
            id="adminTrackingButton"
            v-if="amazeUserCan('administer', 'dsec_calendar')"
            color="primary"
            ><v-icon small>fa fa-cog</v-icon></v-btn
          >
          <h3 class="my-3">Admin Tracking Information</h3>
          <p v-if="extract('viewEvent.admin_tracking', null).length == 0">
            HERE {{ viewEvent.admin_tracking }}
            <em>No tracking information has been entered for this event.</em>
          </p>
          <!-- <p
            v-if="viewEvent.admin_tracking && viewEvent.admin_tracking.priority"
          >
            <strong>Priority for Element 5 Sync Calls:</strong>
            <v-chip
              label
              small
              disabled
              :class="'p-' + viewEvent.admin_tracking.priority"
              >{{ viewEvent.admin_tracking.priority }}</v-chip
            >
          </p> -->
          <p
            v-if="extract('viewEvent.admin_tracking.support_status', false)"
            v-html="adminField('Support Status', 'support_status')"
          ></p>
          <p
            v-if="extract('viewEvent.admin_tracking.events_meeting', false)"
            v-html="adminField('Events Meeting', 'events_meeting')"
          ></p>
          <!-- <p v-if="extract('viewEvent.admin_tracking.status_notes', false)" v-html="adminField('Status Notes', 'status_notes')"></p> -->
          <p
            v-if="extract('viewEvent.admin_tracking.funding_mechanism', false)"
            v-html="adminField('Funding Mechanism', 'funding_mechanism')"
          ></p>
          <p
            v-if="extract('viewEvent.admin_tracking.impact', false)"
            v-html="adminField('Impact of Current Year Funding', 'impact')"
          ></p>
          <div
            v-if="
              extract('viewEvent.admin_tracking.partners_participating', false)
            "
            v-html="
              adminField(
                'DSEC Partners Participating',
                'partners_participating'
              )
            "
          ></div>
        </div>

        <div
          class="surveysWrapper mt-4 mb-4"
          v-if="
            amazeUserCan('administer', 'dsec_calendar') ||
            eventOwner(viewEvent.dsec_partner.id)
          "
        >
          <v-divider class="mb-4" />

          <div
            class="preEventSurveyLinksWrapper"
            v-if="
              eventLinks &&
              extract('viewEvent.required_surveys.pre_survey_required')
            "
          >
            <h4
              v-if="
                eventLinks &&
                extract('viewEvent.pre-survey.0.Date submitted', '') != ''
              "
              class="mb-2 preEventSurveyLink completedLink"
            >
              DSEC Event Planning Form <v-icon>fa fa-check-circle</v-icon>
            </h4>
            <p v-else>
              <a
                v-if="
                  eventLinks && extract('viewEvent.links.pre-survey', false)
                "
                color="primary"
                :href="extract('viewEvent.links.pre-survey', false)"
                target="_blank"
                class="ml-0 viewLink"
              >
                DSEC Event Planning Form
                <v-icon>fas fa-external-link-alt</v-icon>
              </a>
            </p>
          </div>

          <!-- <div
            class="mb-2 actionReportSurveyLinksWrapper"
            v-if="
              eventLinks &&
              extract('viewEvent.required_surveys.action_report_required')
            "
          >
            <h4
              v-if="
                extract('viewEvent.links', false) &&
                extract('viewEvent.action-report.0.Date submitted', '') != ''
              "
              class="completedLink"
            >
              After-Action Report <v-icon>fa fa-check-circle</v-icon>
            </h4>
            <p v-else>
              <a
                v-if="
                  eventLinks &&
                  extract('viewEvent.action-report', false) &&
                  extract('viewEvent.links.action-report', false)
                "
                color="primary"
                :href="extract('viewEvent.links.action-report', false)"
                target="_blank"
                class="ml-0 viewLink"
                >After-Action Report
                <v-icon>fas fa-external-link-alt</v-icon></a
              >
            </p>
          </div> -->

          <!-- <div
            class="postEventSurveyLinksWrapper"
            v-if="
              `DISABLED` &&
              false &&
              eventLinks &&
              extract('viewEvent.required_surveys.post_survey_required')
            "
          >
            <h4
              class="completedLink"
              v-if="
                extract('viewEvent.links', false) &&
                extract('viewEvent.post-survey.0.Date submitted', '') != ''
              "
            >
              Post-Event Form <v-icon>fa fa-check-circle</v-icon>
            </h4>
            <p v-else>
              <a
                color="primary"
                v-if="
                  eventLinks &&
                  false &&
                  `2024-09-05 this is temporarily disabled`
                "
                :href="viewEvent.links['post-survey']"
                target="_blank"
                class="ml-0 viewLink"
                flat
                >Post-Event Form <v-icon>fas fa-external-link-alt</v-icon></a
              >
            </p>
          </div> -->
        </div>

        <div
          class="mt-4 mb-4 preEventResponseDataWrapper"
          v-if="
            (amazeUserCan('admin_view', 'dsec_calendar') ||
              eventOwner(viewEvent.dsec_partner.id)) &&
            extract('viewEvent.pre-survey.0.Date submitted', '') != ''
          "
        >
          <v-divider />
          <div
            class="mt-2 py-2"
            v-if="extract('viewEvent.pre-survey.0.Event/Activity URL', false)"
          >
            <strong>Event/Activity URL:</strong><br />
            <span
              v-html="
                eventLink(viewEvent['pre-survey'][0]['Event/Activity URL'])
              "
            ></span>
          </div>
          <hr
            v-if="extract('viewEvent.pre-survey.0.Event/Activity URL', false)"
          />

          <div
            class="py-2"
            v-if="
              extract('viewEvent.pre-survey.0.Type of Event/Activity', false) ||
              extract(
                'viewEvent.pre-survey.0.Type of Event/Activity [Other]',
                false
              )
            "
          >
            <strong>Type of Event/Activity:</strong><br />
            {{
              extract("viewEvent.pre-survey.0.Type of Event/Activity", false) ==
              "Other"
                ? extract(
                    "viewEvent.pre-survey.0.Type of Event/Activity [Other]",
                    false
                  )
                : extract(
                    "viewEvent.pre-survey.0.Type of Event/Activity",
                    false
                  )
            }}
          </div>
          <hr
            v-if="
              extract('viewEvent.pre-survey.0.Type of Event/Activity', false) ||
              extract(
                'viewEvent.pre-survey.0.Type of Event/Activity [Other]',
                false
              )
            "
          />

          <div
            class="py-2"
            v-if="
              extract(
                'viewEvent.pre-survey.0.Is this event/activity part of a series?',
                false
              )
            "
          >
            <strong>Is this part of a series?</strong><br />
            {{
              extract(
                "viewEvent.pre-survey.0.Is this event/activity part of a series?",
                false
              ) == "Yes"
                ? "Yes, " +
                  extract(
                    "viewEvent.pre-survey.0.How many more sessions will follow this one?",
                    false
                  ) +
                  " events follow"
                : "No"
            }}
          </div>
          <hr
            v-if="
              extract(
                'viewEvent.pre-survey.0.Is this event/activity part of a series?',
                false
              )
            "
          />

          <div
            class="py-2"
            v-if="
              extract(
                'viewEvent.pre-survey.0.By what method is this event/activity conducted?',
                false
              )
            "
          >
            <strong>By what method is this activity/event conducted?</strong
            ><br />
            {{
              viewEvent["pre-survey"][0][
                "By what method is this event/activity conducted?"
              ] || "--"
            }}<br />
            <span
              v-if="
                extract(
                  'viewEvent.pre-survey.0.By what method is this event/activity conducted?'
                ) != 'Virtual' &&
                viewEvent['pre-survey'][0][
                  'Where will this event/activity take place? [Venue][Location]'
                ] != 'N/A'
              "
            >
              Venue:
              {{
                viewEvent["pre-survey"][0][
                  "Where will this event/activity take place? [Venue][Location]"
                ] || "--"
              }}<br />
              City:
              {{
                viewEvent["pre-survey"][0][
                  "Where will this event/activity take place? [City][Location]"
                ] || "--"
              }},
              {{
                viewEvent["pre-survey"][0][
                  "Where will this event/activity take place? [State][Location]"
                ] || "--"
              }}
            </span>
          </div>
          <hr
            v-if="
              extract(
                'viewEvent.pre-survey.0.By what method is this event/activity conducted?'
              )
            "
          />

          <div
            class="py-2"
            v-if="
              extract(
                'viewEvent.pre-survey.0.What is your goal for this event/activity?'
              )
            "
          >
            <strong>Event Goals:</strong><br />
            {{
              viewEvent["pre-survey"][0][
                "What is your goal for this event/activity?"
              ] || "--"
            }}
          </div>
          <hr
            v-if="
              extract(
                'viewEvent.pre-survey.0.What is your goal for this event/activity?'
              )
            "
          />

          <div class="py-2">
            <strong>Participant Type(s):</strong><br />
            {{ group(extractGroupByRegex(/Participant Types/)) }}
          </div>
          <hr />

          <div class="py-2">
            <strong>DSEC strategic goal(s):</strong><br />
            {{
              group(
                extractGroupByRegex(
                  /Which DSEC strategic goals are a focus for this event\/activity/
                )
              )
            }}
          </div>
          <hr />

          <div class="py-2">
            <strong>Assistance requested from:</strong><br />
            <span
              v-html="
                group(
                  extractGroupByRegex(
                    /Would you like assistance from DSEC or DoD/
                  )
                ) || 'None'
              "
            ></span>
          </div>
          <hr />

          <div class="py-2">
            <strong>Anticipated Number of Participants:</strong><br />
            {{
              extract(
                "viewEvent.pre-survey.0.Anticipated Number of Participants",
                "--"
              )
            }}
          </div>
          <hr />

          <div class="py-2" v-if="groupCollaboration">
            <strong
              >The event/activity is being held in collaboration with these DSEC
              partners:</strong
            ><br />
            <span>{{ groupCollaborationString }}</span>
          </div>
          <br />
          <br />
        </div>

        <div class="mt-4 mb-4"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DSECMixin from "./DSECMixin";
import permissionsMixin from "@/mixins/permissionsMixin.js";
import ExtractMixin from "@/mixins/extractMixin.js";
import Sugar from "sugar";
import { EventBus } from "@/components/Events/event-bus.js";

export default {
  mixins: [ExtractMixin, DSECMixin, permissionsMixin],
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      viewEvent: {},
      loading: true
    };
  },
  computed: {
    eventLinks: function () {
      return this.extract("viewEvent.dsec_funded")
        ? this.extract("viewEvent.links", false)
        : false;
    },
    groupCollaborationString: function () {
      return this.groupCollaboration
        ? this.groupCollaboration
          .reduce((str, key) => {
            return str + key + ", ";
          }, "")
          .slice(0, -2)
        : false;
    },
    groupCollaboration: function () {
      var survey = this.extract("viewEvent.pre-survey.0");

      if (!survey) {
        return false;
      }

      var collab = Object.keys(survey).filter((key) =>
        key.includes("Please select the collaboration partners.")
      );

      if (!collab || collab.length < 1) {
        return false;
      }

      collab = collab
        .sort((a, b) => {
          return a < b ? -1 : a === b ? 0 : 1;
        })
        .reduce((obj, key) => {
          if (survey[key] && survey[key].toLowerCase() === "yes") {
            // If it's ugly but it works, it's still ugly, but at least it works. Until it doesn't.
            // We get strings like 'Please select the collaboration partners.  [Bowie State University]'
            // and we need to extract Bowie State University from it.
            obj.push(
              key
                .replace("Please select the collaboration partners.", "")
                .trim()
                .replace("[", "")
                .trim()
                .replace("]", "")
            );
          } else if (key.includes("[Other]") && survey[key]) {
            // Handle that other field.
            obj.push(survey[key]);
          }
          return obj;
        }, []);

      return collab && collab.length > 0 ? collab : false;
    }
  },
  methods: {
    async deleteEvent() {
      if (confirm("Are you sure? This action cannot be undone.")) {
        let response = await this.$http.delete(
          "dsec/events/" + this.viewEvent.id
        );
        if (response.status === 200) {
          EventBus.$emit("refreshEvents");
          this.$emit("close");
        } else {
          console.error("Error: The event was not deleted.");
        }
      }
    },
    adminField(label, variable) {
      if (
        this.viewEvent.admin_tracking &&
        this.viewEvent.admin_tracking[variable]
      ) {
        if (["events_meeting"].indexOf(variable) >= 0) {
          return (
            `<strong>${label}:</strong> ` +
            (this.viewEvent.admin_tracking[variable] ? "Yes" : "No")
          );
        }
        if (["priority", "status"].indexOf(variable) >= 0) {
          return `<strong>${label}:</strong> <v-chip>${this.viewEvent.admin_tracking[variable]}</v-chip>`;
        } else {
          return `<strong>${label}:</strong> ${this.viewEvent.admin_tracking[variable]}`;
        }
      }
    },
    extractGroupByRegex(regex) {
      var fields = this.viewEvent["pre-survey"][0];
      var group = [];

      for (var field in fields) {
        if (regex.test(field)) {
          group.push(field);
        }
      }

      return group;
    },
    group(fields) {
      let items = [];
      let lbl = "";
      let breaks = false;
      for (let i = 0; i < fields.length; i++) {
        lbl = this.label(fields[i], this.viewEvent["pre-survey"][0][fields[i]]);
        if (
          this.viewEvent["pre-survey"][0][fields[i]] === "Yes" &&
          this.viewEvent["pre-survey"][0][fields[i] + "[Comment]"] &&
          this.viewEvent["pre-survey"][0][fields[i] + "[Comment]"] !== "N/A"
        ) {
          lbl +=
            ": " +
            this.viewEvent["pre-survey"][0][fields[i] + "[Comment]"] +
            "<br />";
          breaks = true;
        }
        if (lbl) {
          items.push(lbl);
        }
      }
      return breaks ? items.join("") : items.join(", ");
    },
    label(label, value) {
      if (value === "Yes") {
        let match = label.match(/\[(.*)\]/);
        return match[1];
      } else return null;
    },
    eventLink(link) {
      if (link !== "N/A") {
        return `<a href="${link}" target="_blank">${link}</a>`;
      } else {
        return link;
      }
    },
    convertToAmPm(time24) {
      if (!time24) return "";
      const [hourStr, minute] = time24.split(":");
      let hour = parseInt(hourStr, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12; // Convert to 12-hour format
      return `${hour}:${minute} ${ampm}`;
    }
  },
  async mounted() {
    Sugar.extend();
    this.loading = true;
    let view = await this.$http.get("dsec/events/" + this.item.id);
    this.loading = false;
    this.viewEvent = view.body;
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
@import "src/styles/dsec-labels.scss";

.completedLink {
  color: $amaze-grey-grey-grey-grey;
  font-size: 1.3rem;
}
.viewLink {
  border-bottom: 1px solid #dadada;
  font-family: "Acumen Pro Condensed", "acumin-pro-condensed", sans-serif;
  font-weight: bold;
  font-size: 1.3rem;
  color: $icon-blue;
  &:last-child {
    border-bottom-style: none;
  }
  .v-icon {
    color: $icon-blue;
    margin-left: 4px;
    margin-top: -2px;
    font-size: 1.2rem;
    vertical-align: middle;
  }
  &:hover * {
    color: $amaze-nutmeg;
  }
}
.v-divider {
  background-color: $amaze-yellow;
  border-width: 2px;
  border-color: rgba(0, 0, 0, 0);
  width: 100%;
}
#adminTrackingButton {
  float: right;
  line-height: 15px;
  margin-top: -4px;
}

#eventInfo {
  p {
    word-break: break-all;
    strong {
      // width: 5.25rem;
      display: inline-block;
      &.wide-width {
        width: 8.25rem;
      }
      &.fixed-width {
        width: 5.25rem;
      }
    }
  }
}
</style>
